export const filterRows = (rows, term, keys) => {
  const t = (term || "").trim().toLowerCase();
  if (!t) return rows;
  return rows.filter((r) =>
    keys.some((k) => String(r[k] ?? "").toLowerCase().includes(t))
  );
};

export const sortRows = (rows, field, direction) => {
  const dir = direction === "desc" ? -1 : 1;
  return [...rows].sort((a, b) => {
    const av = a[field] ?? "";
    const bv = b[field] ?? "";
    if (typeof av === "number" && typeof bv === "number") return (av - bv) * dir;
    return String(av).localeCompare(String(bv)) * dir;
  });
};
